
















































































import { GQL_yearlyReportForEmployeeWorkRelations_unit_employees_workRelations } from '@/queries/__generated__/yearlyReportForEmployeeWorkRelations';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EmployeeInfo extends Vue {
  @Prop({ type: Object, required: true }) private workRelation!: GQL_yearlyReportForEmployeeWorkRelations_unit_employees_workRelations;
  @Prop({ type: Number, required: true }) private year!: number;

  private get leaveAndLayoffs() {
    return this.workRelation.leaveAndLayoffs
      .filter(l =>
        this.$dayjs.strict(`${this.year}-01-01`)
          .isBetween(
            this.$dayjs.strict(l.startDate),
            this.$dayjs.strict(l.endDate || '3000-01-01'),
            'year',
            '[]',
          ),
      );
  }
}
